"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Box_1 = __importDefault(require("@mui/system/Box"));
exports.default = (0, styles_1.styled)(Box_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'isVisible'; },
})(function (_a) {
    var _b;
    var theme = _a.theme, isVisible = _a.isVisible;
    return ({
        display: isVisible ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main,
        fontSize: theme.typography.fontSize,
        lineHeight: 1.2,
        float: 'right',
    });
});
